<template>
  <div class="fix">
    <div class="l" v-for="(item,index) in searchItemTwo" :key="index">
      <search-item :searchData="item" :columns="columns" :valueSet="valueSet" @resetSearchArr="resetSearchArr"></search-item>
    </div>
    <q-btn size='9px' class="l mr10" :icon="popupProxy ? 'fas fa-angle-double-up' : 'fas fa-angle-double-down'">
      <q-popup-proxy v-model="popupProxy">
        <div class="p10" style="width: 470px">
          <div class="fix pb10" v-for="(item,index) in searchItemLast" :key="index">
            <search-item class="l" :searchData="item" :columns="columns" :valueSet="valueSet" @resetSearchArr="resetSearchArr"></search-item>
            <q-btn size='9px' class="r mr10" icon="fas fa-trash-alt" @click="delSearchItem(item,index)"></q-btn>
          </div>
          <div class="fix">
            <q-btn size='9px' class="r mr10" color="primary" icon="fas fa-search" @click="searchFun"></q-btn>
            <q-btn size='9px' class="r mr10" icon="fas fa-plus" @click="addSearchItem"></q-btn>
          </div>
        </div>
      </q-popup-proxy>
    </q-btn>
    <q-btn size='9px' class="l mr10" color="primary" icon="fas fa-search" @click="searchFun"></q-btn>
  </div>
</template>

<script>
import {computed, onMounted, ref, toRef, watch} from "vue";
import searchItem from './search-item';
import {isNotEmpty} from "../../../tools/utils";
export default {
  name: "search",
  props:['columns','valueSet','onlyKey'],
  components:{searchItem},
  setup(props,context){
    let serachArr = ref([]);
    let popupProxy = ref(false);
    let searchItemTwo = computed(()=>{
      return serachArr.value.filter((item,index)=>{
        return index < 2
      })
    });
    let searchItemLast = computed(()=>{
      return serachArr.value.filter((item,index)=>{
        return index > 1
      })
    });
    function delSearchItem(delItem,delIndex){
      let arr = serachArr.value.filter((item,idnex)=>{
        return idnex != delIndex
      });
      serachArr.value = arr;
      resetSearchArr();
    }
    function addSearchItem(){
      serachArr.value.push({
        field:'',
        condition:'=',
        value:''
      });
      resetSearchArr();
    }
    function resetSearchArr(){
      serachArr.value.forEach((item,index)=>{
        serachArr.value.index = index;
      });
      if(isNotEmpty(props.onlyKey)){
        localStorage.setItem(`SEARCH_ITEM-${props.onlyKey}`,JSON.stringify(serachArr.value));
      }
    }
    function searchFun(){

    }
    function init(){
      let arr = isNotEmpty(props.onlyKey) ? JSON.parse(localStorage.getItem(`SEARCH_ITEM-${props.onlyKey}`)) : [];
      if(isNotEmpty(arr)){
        serachArr.value=arr;
      }else{
        serachArr.value=[];
        [1,2,3].forEach((searchItemData,index)=>{
          let searchItem = {
            field:props.columns[index].field,
            condition:'=',
            value:'',
          };
          serachArr.value.push(searchItem)
        });
        resetSearchArr();
      }
    }
    onMounted(()=>{
      init();
    })
    return{
      serachArr,
      searchItemTwo,
      searchItemLast,
      popupProxy,
      addSearchItem,
      delSearchItem,
      resetSearchArr,
      searchFun
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .q-field--dense .q-field__control {
  min-height: 24px;
  height: 24px;
  font-size: 12px;
}
</style>
